import { render } from "./NcrmDealDetails.vue?vue&type=template&id=2131f620&scoped=true"
import script from "./NcrmDealDetails.vue?vue&type=script&lang=js"
export * from "./NcrmDealDetails.vue?vue&type=script&lang=js"

import "./NcrmDealDetails.vue?vue&type=style&index=0&id=2131f620&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2131f620"]])

export default __exports__